<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="config-box">
        <el-form
          ref="form"
          :model="form"
          class="form custom-form"
          :rules="rulesFour"
          label-position="top"
        >
<!--          <el-form-item label="验证方式">-->
<!--            <el-radio v-model="check" label="1">使用旧密码验证</el-radio>-->
<!--            <el-radio v-model="check" label="2">使用短信验证码验证</el-radio>-->
<!--          </el-form-item>-->
          <template v-if="check === '1'">
            <el-form-item label="旧密码" prop="password">
              <el-input
                v-model="form.password"
                clearable
                style="width: 100%"
                type="password"
                show-password
                autocomplete="off"
                placeholder="请输入原密码"
                maxlength="30"
              />
            </el-form-item>
          </template>
          <template v-if="check === '2'">
            <div class="message-tip">
              系统将给您的手机
              <span class="color1269FF">{{ form.phone }}</span> 发送验证码
            </div>
            <el-form-item label="短信验证码" prop="sms">
              <el-input
                v-model.trim="form.sms"
                placeholder="请输入短信验证码"
                id="code"
                maxLength="8"
              >
                <div
                  slot="suffix"
                  class="code-image"
                  :class="disabled ? 'code-image-disable' : ''"
                  @click="disabled ? '' : getMsg()"
                >
                  {{ innerTxt }}
                </div>
              </el-input>
            </el-form-item>
          </template>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="form.newPassword"
              clearable
              style="width: 100%"
              type="password"
              autocomplete="off"
              show-password
              placeholder="请输入新密码"
              maxlength="30"
            />
            <div class="tip">
              新密码规则：8-18位，需包含大写字母、小写字母、特殊符号及数字
            </div>
          </el-form-item>
          <el-form-item label="确认新密码" prop="recheckNewPassword">
            <el-input
              v-model="form.recheckNewPassword"
              clearable
              style="width: 100%"
              type="password"
              show-password
              autocomplete="off"
              placeholder="请输入确认新密码"
              maxlength="30"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template v-slot:footer>
      <el-button type="default" @click.stop="handleCancel()">取消</el-button>
      <el-button
        type="primary"
        @click.stop="submitForm()"
        :loading="dialogObj.btnLoading"
        >确认</el-button
      >
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validateIdAccount, validatePhone } from "@/utils/validate";
import { updatePwdForOld, updatePwdForMsg, getCodeMsg } from "@/Layout/api";
import { getUserData } from "@/views/commonApi";
export default {
  name: "UpdatePassword",
  components: {
    DialogContainer,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.form.recheckNewPassword !== "") {
        this.$refs.form.validateField("recheckPassword");
      }
      callback();
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === this.form.password) {
        callback(new Error("新密码不能和旧密码一致!"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("两次输入的新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      timer: null,
      disabled: false,
      innerTxt: "获取验证码",
      check: "1",
      isDisabled: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改密码",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.isDisabled = false;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      // 账号配置
      form: {
        password: "",
        newPassword: "",
        recheckNewPassword: "",
        sms: "",
        phone: "",
      },
      userInfo: {},
      rulesFour: {
        sms: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号" },
          { validator: validatePhone, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入原密码" },
          // { validator: validateIdAccount, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码" },
          { validator: validatePass, trigger: "blur" },
          { validator: validatePass1, trigger: "blur" },
        ],
        recheckNewPassword: [
          { required: true, message: "请确认新密码" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    check(val) {
      this.$refs.form.resetFields();
    },
  },
  mounted() {},
  methods: {
    getUserInfo() {
      getUserData().then((res) => {
        if (res.code === 200) {
          // this.userInfo = res.data;
          this.form.phone = res.data.phone;
        }
      });
    },
    setTimer() {
      let time = 60;
      // 禁用按钮
      this.disabled = true;
      // 开启定时器
      this.timer = setInterval(() => {
        // 判断剩余时间
        if (time === 0) {
          // 清除定时器并复原按钮
          clearInterval(this.timer);
          this.disabled = false;
          this.innerTxt = `获取验证码`;
        } else {
          this.innerTxt = `${time}秒后可重新获取`;
          time--;
        }
      }, 1000);
    },
    getMsg() {
      getCodeMsg(this.form.phone).then((res) => {
        if (res.code === 200) {
          this.setTimer();
        }
      });
      // this.$refs.form.validateField("phone", (valid) => {
      //   if (!valid) {
      //
      //   }
      // });
    },
    // 提交数据 for old
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          if (this.check === "1") {
            let par = {
              oldPwd: this.form.password,
              newPwd: this.form.newPassword,
            };
            updatePwdForOld(par)
              .then((res) => {
                this.dialogObj.btnLoading = false;
                if (res.code === 200) {
                  this.$message.success("修改成功");
                  this.dialogObj.show = false;
                }
              })
              .catch((e) => {
                this.dialogObj.btnLoading = false;
              });
          } else {
            let par = {
              newPwd: this.form.newPassword,
              phone: this.form.phone,
              sms: this.form.sms,
            };
            updatePwdForMsg(par)
              .then((res) => {
                this.dialogObj.btnLoading = false;
                if (res.code === 200) {
                  this.$message.success("修改成功");
                  this.dialogObj.show = false;
                }
              })
              .catch((e) => {
                this.dialogObj.btnLoading = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.dialogObj.beforeClose();
    },
    handleClick() {},
    init() {
      this.check = "1";
      this.getUserInfo();
      this.dialogObj.show = true;
    },
  },
};
</script>
<style lang="scss">
.custom-form {
  .second-form {
    .form-two-box {
      .el-checkbox__label {
        color: #718096;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.config-box {
  padding: 0 0.2rem 0;
  //min-height: rem;
  .third-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
  .second-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      display: flex;
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      flex-wrap: wrap;
      .form-two-box {
        width: 2rem;
        padding: 0.1rem 0;
      }
    }
  }
  .message-tip {
    background: #1269ff1a;
    width: 100%;
    height: 0.32rem;
    display: flex;
    align-items: center;
    padding-left: 0.1rem;
    border-radius: 0.06rem;
    position: relative;
    top: -0.1rem;
  }
  .tip {
    color: rgba(0, 0, 0, 0.25);
    font-size: 0.12rem;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0.2rem;
  }
  .code-image {
    width: 1.1rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1966ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    width: 1.6rem;
    color: #999999;
  }
}
</style>
